/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Tenantusergroup2Inputs */

const en_entity_tenantusergroup2 = /** @type {(inputs: Entity_Tenantusergroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tenant User Group`)
};

const de_entity_tenantusergroup2 = /** @type {(inputs: Entity_Tenantusergroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mandanten-Benutzergruppe`)
};

/**
* | output |
* | --- |
* | "Tenant User Group" |
*
* @param {Entity_Tenantusergroup2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_tenantusergroup2 = /** @type {((inputs?: Entity_Tenantusergroup2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Tenantusergroup2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_tenantusergroup2(inputs)
	return de_entity_tenantusergroup2(inputs)
});
export { entity_tenantusergroup2 as "entity_tenantUserGroup" }